import Component from '../../js/_Component';
import ResizeClasses from '../../js/util/_ResizeClasses';

const CNAME = 'c-block-image-and-text-box';

export default class BlockImageAndTextBox extends Component {
	constructor(element: HTMLElement) {
		super(element);

		const textElements = this.element.querySelectorAll(`.${CNAME}--text`);

		textElements.forEach((textElement) => {
			new ResizeClasses(textElement, {
				'm-one-column': {
					max: 448,
				},
			});
		});
	}
}

Component.register(BlockImageAndTextBox, 'BlockImageAndTextBox');
